import { ButtonDock } from '@focuslee/shared-mini-app';
import { FC, useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListCategory } from '../client/types';
import { GoalsListView } from '../components/common/GoalsListView';
import { useCachedCategoriesWithFallback } from '../hooks/caching/category';
import { useCachedGoalsWithFallback } from '../hooks/caching/goal';
import { useCachedUserGoalCompletion } from '../hooks/caching/user';

export const GoalsViewPage: FC = () => {
  const navigate = useNavigate();

  const { goals, loading: goalsLoading } = useCachedGoalsWithFallback();
  const { categories, loading: categoriesLoading } = useCachedCategoriesWithFallback();
  const goalCompletion = useCachedUserGoalCompletion();

  const loading = goalsLoading || categoriesLoading;

  const handleBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  const categoryMap: Record<string, ListCategory> = useMemo(() =>
    Object.fromEntries(categories.map(c => [c.id, c])),
    [categories]
  );

  const activeGoals = useMemo(() => goals.filter(g => g.active), [goals]);

  return (
    <GoalsListView
      activeGoals={activeGoals}
      goalCompletion={goalCompletion}
      categoryMap={categoryMap}
      loading={loading}
      footer={<ButtonDock main={{ text: 'Back', onClick: handleBack, loading, navigation: 'back' }} />}
    />
  );
};
